module.exports = __webpack_public_path__ + "img/weibos948.3d70f1b4.svg";